
import { createTranslations } from '../../i18n/types';

export default createTranslations({
  en: {
    waiting: 'Waiting',
    inProgress: 'Live',
    completed: 'Finished',
    open: 'Open',
  },
  ru: {
    waiting: 'Ожидание',
    inProgress: 'Идёт',
    completed: 'Завершён',
    open: 'Открыть',
  },
  uz: {
    waiting: 'Kutilmoqda',
    inProgress: 'Jonli',
    completed: 'Tugadi',
    open: 'Ochish',
  },
  fa: {
    waiting: 'در انتظار',
    inProgress: 'زنده',
    completed: 'تمام‌شده',
    open: 'باز کن',
  },
});
